import React, { useState } from 'react'
import { Box, CardActionArea, CardContent, Typography } from '@mui/material'
import { Cell, Pie, PieChart } from 'recharts'

type Needle = {
  value: number
  cx: number
  cy: number
  iR: number
  oR: number
  color: string
  total?: number
}

type Props = {
  totalEngagementPercentage?: number | null
}

export const PieChartEngagement = ({ totalEngagementPercentage }: Props) => {
  const cx = 150
  const cy = 150
  const iR = 60
  const oR = 100
  const total = 100
  const value = totalEngagementPercentage ?? 0

  const RADIAN = Math.PI / 180
  const backgroundData = [
    { name: 'Muito Baixo', value: 10, color: '#DC3545' },
    { name: 'Baixo', value: 20, color: '#FF851B' },
    { name: 'Moderado', value: 30, color: '#FFC107' },
    { name: 'Bom', value: 20, color: '#28A745' },
    { name: 'Excelente', value: 20, color: '#198754' }
  ]

  const renderNeedle = ({ value, cx, cy, iR, oR, color, total = 100 }: Needle) => {
    const angle = 180 * (1 - value / total)
    const length = (iR + oR) / 1.7
    const r = 5

    const x0 = cx
    const y0 = cy
    const sin = Math.sin(-RADIAN * angle)
    const cos = Math.cos(-RADIAN * angle)

    const x1 = x0 + r * sin
    const y1 = y0 - r * cos
    const x2 = x0 - r * sin
    const y2 = y0 + r * cos
    const xp = x0 + length * cos
    const yp = y0 + length * sin

    return [
      <circle key="needle-base" cx={x0} cy={y0} r={r} fill={color} />,
      <path
        key="needle"
        d={`M${x1} ${y1} L${x2} ${y2} L${xp} ${yp} Z`}
        fill={color}
      />
    ]
  }

  return (
    <CardActionArea sx={{ height: '100%' }}>
      <CardContent>
        <Box style={{ width: '100%', height: '100%' }}>
          <Typography fontSize={25} fontWeight="bold" color="#d6500d">Percentual de Engajamento</Typography>
          <PieChart width={300} height={280} >
            <Pie
              data={backgroundData}
              startAngle={180}
              endAngle={0}
              cx={cx}
              cy={cy}
              innerRadius={iR}
              outerRadius={oR}
              dataKey="value"
              stroke="none"
            >
              {backgroundData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            {renderNeedle({ value, cx, cy, iR, oR, color: '#fff', total })}
            <text
              x={cx}
              y={cy + 50}
              textAnchor="middle"
              dominantBaseline="middle"
              fill="#fff"
              fontSize={30}
              fontWeight="bold"
            >
              {`${value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%`}
            </text>
          </PieChart>
        </Box>
      </CardContent>
    </CardActionArea>
  )
}
